import { useEffect, useState, useCallback } from 'react';
import * as virtualAgentApi from '../../../../VirtualAgent/VirtualAgentAPI';
import { useAppContext } from '../../../../../Context/AppContext';
import { useFeatureFlagContext } from '../../../../../Context/FeatureFlagContext';
import { getPropertyList } from '../../../../../Pages/Features/SchedulingPage/schedulingApi';

export const useAiNurturePropertyData = () => {
  const { companyId } = useAppContext();
  const { isAiNurtureEnabled } = useFeatureFlagContext();

  const [aiNurturePropertyData, setAiNurturePropertyData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasAiNurtureError, setHasAiNurtureError] = useState(false);
  const [aiNurtureEnabledPropertyCount, setAiNurtureEnabledPropertyCount] =
    useState(0);

  const fetchData = useCallback(async () => {
    try {
      setHasAiNurtureError(false);
      setIsLoading(true);
      const properties = await getPropertyList();
      const propertyIds = properties.map((prop) => prop.id);

      const response = await virtualAgentApi.getProductsEnabledForProperties(
        JSON.stringify(propertyIds),
      );

      const responseProducts = Array.isArray(response) ? response : [];

      const nurtureProductEnabledMap = responseProducts.reduce(
        (productsMap, product) => {
          productsMap[product.property_id] = product.nurture_product_enabled;
          return productsMap;
        },
        {},
      );

      const aiNurtureProductEnabledProperties = properties.filter(
        (property) => nurtureProductEnabledMap[property.id],
      );

      if (aiNurtureProductEnabledProperties.length > 0) {
        const { results: virtualAgents } =
          await virtualAgentApi.getVirtualAgents(companyId, 1, 1000);

        const virtualAgentMap = virtualAgents.reduce((agentMap, agent) => {
          agentMap[agent.property_id] = agent.is_ai_nurture_enabled;
          return agentMap;
        }, {});

        let activePropertyCount = 0;
        const propertyData = aiNurtureProductEnabledProperties.map(
          (property) => {
            const isAiNurtureEnabled = virtualAgentMap[property.id] || false;
            if (isAiNurtureEnabled) {
              activePropertyCount++;
            }
            return {
              name: property.name,
              isAiNurtureEnabled,
            };
          },
        );

        setAiNurtureEnabledPropertyCount(activePropertyCount);
        setAiNurturePropertyData(propertyData);
      }
    } catch (error) {
      setHasAiNurtureError(true);
    } finally {
      setIsLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    if (isAiNurtureEnabled) {
      fetchData();
    }
  }, [fetchData, isAiNurtureEnabled]);

  return {
    aiNurtureEnabledPropertyCount,
    aiNurturePropertyData,
    getAiNurturePropertyData: fetchData,
    hasAiNurtureError,
    isLoading,
  };
};
